module.exports = __webpack_public_path__ + "16ff00b8b780ad23b5edef1d0561450d.MP3";